



































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import Enums from '@/lib/enums'
import DateUtils from '@/common/js/DateUtils'


class PageFlowRequest extends PageRequest {
    orderType: number;
    overTimeHours: number;
    PlatformType: number;
    constructor() {
        super();
        this.orderType = 0;
        //this.PlatformType = 0;
        this.overTimeHours = 24;
    }
}

@Component({
    name: "abnormalreceivingorder",
})
export default class flows extends AbpBase {
    ordertype = Enums.getEnum(Enums.WarehouseOrderType, true);
    PlatformType = Enums.getEnum(Enums.PlatformType, true);
    pagerequest: PageFlowRequest = new PageFlowRequest();
    createTime: Date[] = [];
    get list() {
        return this.$store.state.abnormalreceivingorder.list;
    };
    get loading() {
        return this.$store.state.abnormalreceivingorder.loading;
    };
    pageChange(page: number) {
        this.$store.commit('abnormalreceivingorder/setCurrentPage', page);
        this.getpage();
    };
    pagesizeChange(pagesize: number) {
        this.$store.commit('abnormalreceivingorder/setPageSize', pagesize);
        this.getpage();
    };

    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        //filters
        await this.$store.dispatch({
            type: 'abnormalreceivingorder/getAll',
            data: this.pagerequest
        })
    }
    async searchPage() {
        this.$store.state.abnormalreceivingorder.currentPage = 1;
        this.getpage();
    }
    get pageSize() {
        return this.$store.state.abnormalreceivingorder.pageSize;
    }
    get totalCount() {
        return this.$store.state.abnormalreceivingorder.totalCount;
    }
    get currentPage() {
        return this.$store.state.abnormalreceivingorder.currentPage;
    }
    columns = [{

        title: '仓库名称',
        key: 'warehouseName',
            width: 364,
            //fixed: 'left',
    }, {
        title: '用户编码',
        key: 'userCode',
        width: 300,
    }, {
        title: '订单编号',
        key: 'orderNumber',
        width: 300,

        }, {
            title: '接收时间',
            key: 'receivedTime',
            width: 300,
            render: (h: any, params: any) => {
                return h('span', params.row.receivedTime ? DateUtils.formatLongDate(new Date(params.row.receivedTime)) : '');
            }
        },
        {
            title: '支付时间',
            key: 'payTime',
            width: 300,
            render: (h: any, params: any) => {
                return h('span', params.row.payTime ? DateUtils.formatLongDate(new Date(params.row.payTime)) : '');
            }
        },
    ]
    async created() {
        this.getpage();
    }
}
